module.exports = __webpack_public_path__ + "img/logo.0327e090.png";